var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 16.9912C0.955092 16.9836 -2.84008 7.82065 2.4897 2.48081C5.65355 -0.816278 11.3466 -0.816809 14.5104 2.48095C19.8402 7.82125 16.0445 16.9841 8.50004 16.9912ZM8.50004 0.721751C4.21593 0.721751 0.730539 4.20714 0.730539 8.49125C1.15733 18.7986 15.8443 18.7955 16.2695 8.49119C16.2695 4.20714 12.7842 0.721751 8.50004 0.721751Z",
    fill: "url(#paint0_linear_3898_34081)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 0.721751C4.21593 0.721751 0.730539 4.20714 0.730539 8.49125C1.15733 18.7986 15.8443 18.7955 16.2695 8.49119C16.2695 4.20714 12.7842 0.721751 8.50004 0.721751Z",
    fill: "url(#paint1_linear_3898_34081)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.115 10.4609H4.9525C4.78235 10.4609 4.64441 10.6011 4.64441 10.774C4.64441 12.6686 6.38914 14.21 8.53374 14.21C10.6783 14.21 12.4231 12.6686 12.4231 10.774C12.423 10.6011 12.2851 10.4609 12.115 10.4609Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02332 13.4279C6.7368 12.3882 7.56719 11.8613 8.49981 11.8613C9.46243 11.8613 10.2814 12.3727 10.9873 13.4185C9.46631 14.7016 7.54627 14.7051 6.02332 13.4279Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0718 6.45635L11.7701 8.17353L13.4731 6.4515C14.2768 5.55886 13.0278 4.32123 12.0894 5.21228C11.9074 5.37955 11.6208 5.37625 11.4429 5.20486C10.5786 4.36613 9.23478 5.48513 10.0718 6.45635Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53334 6.45635L5.23166 8.17353L6.93466 6.45149C7.7383 5.55889 6.48937 4.32123 5.55101 5.21228C5.36895 5.37955 5.08236 5.37625 4.90448 5.20485C4.04018 4.36612 2.69632 5.48512 3.53334 6.45635Z",
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3898_34081",
    x1: 1.13698,
    y1: 12.7471,
    x2: 15.8558,
    y2: 4.24123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3898_34081",
    x1: 1.13698,
    y1: 12.7471,
    x2: 15.8558,
    y2: 4.24123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.5a72e450ce18bab221fad0147dd6b9fa.svg";
export { ForwardRef as ReactComponent };